module.exports = __webpack_public_path__ + "media/promo/velle/images/zenShare-d53e09548c2a58c10f7603f6ccaad72a.svg";